import { Query } from "material-table";

export function constructQueryParams<T extends object>(query: Query<T>) {
  return {
    offset: query.page * query.pageSize,
    limit: query.pageSize,
    search: query.search,
    order: query.orderBy && [
      {
        field: query.orderBy.field,
        order: query.orderDirection.toUpperCase()
      }
    ]
  };
}
